// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RefundPolicyRouteImport } from './routes/refund-policy'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PaymentProtectionRefundsRouteImport } from './routes/payment-protection-refunds'
import { Route as PaymentProtectionPolicyRouteImport } from './routes/payment-protection-policy'
import { Route as LegalNoticeRouteImport } from './routes/legal-notice'
import { Route as HelpRouteImport } from './routes/help'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DevicePolicyRouteImport } from './routes/device-policy'
import { Route as DeviceLimitRouteImport } from './routes/device-limit'
import { Route as BannedRouteImport } from './routes/banned'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AcceptableUseRouteImport } from './routes/acceptable-use'
import { Route as AboutRouteImport } from './routes/about'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PortfolioUsernameRouteImport } from './routes/portfolio.$username'
import { Route as AuthenticatedWalletRouteImport } from './routes/_authenticated/wallet'
import { Route as AuthenticatedVerifyRouteImport } from './routes/_authenticated/verify'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedPortfolioRouteImport } from './routes/_authenticated/portfolio'
import { Route as AuthenticatedPlansRouteImport } from './routes/_authenticated/plans'
import { Route as AuthenticatedInvoicesRouteImport } from './routes/_authenticated/invoices'
import { Route as AuthenticatedEscrowRouteImport } from './routes/_authenticated/escrow'
import { Route as AuthenticatedDevicesRouteImport } from './routes/_authenticated/devices'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedChatRouteImport } from './routes/_authenticated/chat'
import { Route as AuthenticatedCalendarRouteImport } from './routes/_authenticated/calendar'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects.index'
import { Route as AuthenticatedCheckoutPlanRouteImport } from './routes/_authenticated/checkout.$plan'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminWithdrawalsRouteImport } from './routes/_authenticated/admin.withdrawals'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin.users'
import { Route as AuthenticatedAdminPaymentsRouteImport } from './routes/_authenticated/admin.payments'
import { Route as AuthenticatedAdminNotificationsRouteImport } from './routes/_authenticated/admin.notifications'
import { Route as AuthenticatedAdminEventsRouteImport } from './routes/_authenticated/admin.events'
import { Route as AuthenticatedAdminDisputesRouteImport } from './routes/_authenticated/admin.disputes'
import { Route as AuthenticatedAdminDevicesRouteImport } from './routes/_authenticated/admin.devices'
import { Route as AuthenticatedAdminBansRouteImport } from './routes/_authenticated/admin.bans'
import { Route as AuthenticatedAdminAuditRouteImport } from './routes/_authenticated/admin.audit'
import { Route as AuthenticatedProjectsIdIndexRouteImport } from './routes/_authenticated/projects.$id.index'
import { Route as AuthenticatedProjectsIdWorkspaceRouteImport } from './routes/_authenticated/projects.$id.workspace'
import { Route as AuthenticatedProjectsIdChatRouteImport } from './routes/_authenticated/projects.$id.chat'
import { Route as AuthenticatedAdminUsersIdRouteImport } from './routes/_authenticated/admin.users.$id'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RefundPolicyRoute = RefundPolicyRouteImport.update({
            id: '/refund-policy',path: '/refund-policy',getParentRoute: () => rootRouteImport
          })
const RefundRoute = RefundRouteImport.update({
            id: '/refund',path: '/refund',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PaymentProtectionRefundsRoute = PaymentProtectionRefundsRouteImport.update({
            id: '/payment-protection-refunds',path: '/payment-protection-refunds',getParentRoute: () => rootRouteImport
          })
const PaymentProtectionPolicyRoute = PaymentProtectionPolicyRouteImport.update({
            id: '/payment-protection-policy',path: '/payment-protection-policy',getParentRoute: () => rootRouteImport
          })
const LegalNoticeRoute = LegalNoticeRouteImport.update({
            id: '/legal-notice',path: '/legal-notice',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DevicePolicyRoute = DevicePolicyRouteImport.update({
            id: '/device-policy',path: '/device-policy',getParentRoute: () => rootRouteImport
          })
const DeviceLimitRoute = DeviceLimitRouteImport.update({
            id: '/device-limit',path: '/device-limit',getParentRoute: () => rootRouteImport
          })
const BannedRoute = BannedRouteImport.update({
            id: '/banned',path: '/banned',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AcceptableUseRoute = AcceptableUseRouteImport.update({
            id: '/acceptable-use',path: '/acceptable-use',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PortfolioUsernameRoute = PortfolioUsernameRouteImport.update({
            id: '/portfolio/$username',path: '/portfolio/$username',getParentRoute: () => rootRouteImport
          })
const AuthenticatedWalletRoute = AuthenticatedWalletRouteImport.update({
            id: '/wallet',path: '/wallet',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedVerifyRoute = AuthenticatedVerifyRouteImport.update({
            id: '/verify',path: '/verify',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPortfolioRoute = AuthenticatedPortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPlansRoute = AuthenticatedPlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedInvoicesRoute = AuthenticatedInvoicesRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedEscrowRoute = AuthenticatedEscrowRouteImport.update({
            id: '/escrow',path: '/escrow',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDevicesRoute = AuthenticatedDevicesRouteImport.update({
            id: '/devices',path: '/devices',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedChatRoute = AuthenticatedChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCalendarRoute = AuthenticatedCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProjectsIndexRoute = AuthenticatedProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCheckoutPlanRoute = AuthenticatedCheckoutPlanRouteImport.update({
            id: '/checkout/$plan',path: '/checkout/$plan',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminWithdrawalsRoute = AuthenticatedAdminWithdrawalsRouteImport.update({
            id: '/withdrawals',path: '/withdrawals',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPaymentsRoute = AuthenticatedAdminPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminNotificationsRoute = AuthenticatedAdminNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEventsRoute = AuthenticatedAdminEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminDisputesRoute = AuthenticatedAdminDisputesRouteImport.update({
            id: '/disputes',path: '/disputes',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminDevicesRoute = AuthenticatedAdminDevicesRouteImport.update({
            id: '/devices',path: '/devices',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBansRoute = AuthenticatedAdminBansRouteImport.update({
            id: '/bans',path: '/bans',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedProjectsIdIndexRoute = AuthenticatedProjectsIdIndexRouteImport.update({
            id: '/projects/$id/',path: '/projects/$id/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProjectsIdWorkspaceRoute = AuthenticatedProjectsIdWorkspaceRouteImport.update({
            id: '/projects/$id/workspace',path: '/projects/$id/workspace',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProjectsIdChatRoute = AuthenticatedProjectsIdChatRouteImport.update({
            id: '/projects/$id/chat',path: '/projects/$id/chat',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminUsersIdRoute = AuthenticatedAdminUsersIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAdminUsersRoute
          })





const AuthenticatedAdminUsersRouteChildren = {
  AuthenticatedAdminUsersIdRoute: AuthenticatedAdminUsersIdRoute
}

const AuthenticatedAdminUsersRouteWithChildren = AuthenticatedAdminUsersRoute._addFileChildren(AuthenticatedAdminUsersRouteChildren)



const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,AuthenticatedAdminBansRoute: AuthenticatedAdminBansRoute,AuthenticatedAdminDevicesRoute: AuthenticatedAdminDevicesRoute,AuthenticatedAdminDisputesRoute: AuthenticatedAdminDisputesRoute,AuthenticatedAdminEventsRoute: AuthenticatedAdminEventsRoute,AuthenticatedAdminNotificationsRoute: AuthenticatedAdminNotificationsRoute,AuthenticatedAdminPaymentsRoute: AuthenticatedAdminPaymentsRoute,AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRouteWithChildren,AuthenticatedAdminWithdrawalsRoute: AuthenticatedAdminWithdrawalsRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedCalendarRoute: AuthenticatedCalendarRoute,AuthenticatedChatRoute: AuthenticatedChatRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedDevicesRoute: AuthenticatedDevicesRoute,AuthenticatedEscrowRoute: AuthenticatedEscrowRoute,AuthenticatedInvoicesRoute: AuthenticatedInvoicesRoute,AuthenticatedPlansRoute: AuthenticatedPlansRoute,AuthenticatedPortfolioRoute: AuthenticatedPortfolioRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedVerifyRoute: AuthenticatedVerifyRoute,AuthenticatedWalletRoute: AuthenticatedWalletRoute,AuthenticatedCheckoutPlanRoute: AuthenticatedCheckoutPlanRoute,AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,AuthenticatedProjectsIdChatRoute: AuthenticatedProjectsIdChatRoute,AuthenticatedProjectsIdWorkspaceRoute: AuthenticatedProjectsIdWorkspaceRoute,AuthenticatedProjectsIdIndexRoute: AuthenticatedProjectsIdIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,SplatRoute: SplatRoute,AboutRoute: AboutRoute,AcceptableUseRoute: AcceptableUseRoute,AuthRoute: AuthRoute,BannedRoute: BannedRoute,DeviceLimitRoute: DeviceLimitRoute,DevicePolicyRoute: DevicePolicyRoute,FaqRoute: FaqRoute,HelpRoute: HelpRoute,LegalNoticeRoute: LegalNoticeRoute,PaymentProtectionPolicyRoute: PaymentProtectionPolicyRoute,PaymentProtectionRefundsRoute: PaymentProtectionRefundsRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,RefundRoute: RefundRoute,RefundPolicyRoute: RefundPolicyRoute,ResetPasswordRoute: ResetPasswordRoute,SecurityRoute: SecurityRoute,TermsRoute: TermsRoute,PortfolioUsernameRoute: PortfolioUsernameRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)